import { Component, ViewChild, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-enable-step-modal',
  templateUrl: './enable-step-modal.component.html',
  imports: [AlertComponent, ButtonComponent, ModalComponent, I18NextPipe, ModalFooterDirective]
})
export class EnableStepModalComponent {
  private i18nPipe = inject(I18NextPipe);

  public readonly alertType = MbsPopupType;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  save(): void {
    this.baseModal.save(true);
  }

  close(): void {
    this.baseModal.close();
  }
}
